//
//
//
//
//
//
//
//
//
//
//
//
import { Navbar, Sidebar, AppMain, TagsView } from './components';
export default {
  name: 'layout',
  components: {
    Navbar: Navbar,
    Sidebar: Sidebar,
    AppMain: AppMain,
    TagsView: TagsView
  },
  data: function data() {
    return {
      linkageVisible: true
    };
  },
  computed: {
    sidebar: function sidebar() {
      return this.$store.state.app.sidebar;
    }
  }
};